import { render, staticRenderFns } from "./FlashCardAdmin.vue?vue&type=template&id=4e1257da&"
import script from "./FlashCardAdmin.vue?vue&type=script&lang=js&"
export * from "./FlashCardAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports